<div class="login-page-container">


    <div class="login-container" id=login-container>

        <!-- svg logo -->
        <div class="logo">
            <mat-icon class="logo-icon" [svgIcon]="'license_manager_login'"></mat-icon>
        </div>


        <!-- motto (subtitle) section -->
        <div class="motto is-h6">
            {{ 'reset_password_title' | translate }}
        </div>

        <form class="login-form-container" [formGroup]="resetPasswordForm">
            <mat-form-field appearance="outline" autocomplete="off">
                <input matInput type="email" class="is-h6" placeholder='{{"email" | translate}}' formControlName="email"
                    autocomplete="new-email">
                <mat-error *ngIf="resetPasswordForm.get('email')?.hasError('email')">
                    Email non valida
                </mat-error>
            </mat-form-field>
            <button mat-flat-button type="submit" color="primary" class="clickable is-button" (click)="resetPasswordRequest()"
                [disabled]="!resetPasswordForm?.valid">
                <span>{{'send_request_reset_password' | translate | uppercase}}</span>
            </button>
            <div class="subtitle clickable mt--20 align-center flex center">
                <span class="mr--5">{{"back_to_login" | translate}}</span>
                <span style="font-weight: 500; cursor: pointer;" (click)="goToLogin()">
                    {{"go_to_login" | translate }}
                </span>
            </div>

        </form>
    </div>

</div>